import React from 'react';
import { Select, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useGlobalTheme, THEME_OPTIONS } from '../../contexts/ThemeContext';

export default function ThemeSelector() {
  const { t } = useTranslation();
  const { globalTheme, setGlobalTheme } = useGlobalTheme();

  return (
    <Select
      size="small"
      value={globalTheme}
      onChange={(e) => setGlobalTheme(e.target.value)}
      sx={{
        minWidth: 130,
        bgcolor: 'background.paper',
        fontSize: '0.875rem',
        '.MuiSelect-select': { py: 0.75, px: 1.5 }
      }}
    >
      {THEME_OPTIONS.map((opt) => (
        <MenuItem key={opt.value} value={opt.value} sx={{ fontSize: '0.875rem' }}>
          {t(`theme.${opt.value}`)}
        </MenuItem>
      ))}
    </Select>
  );
}
